import { render } from "./weixin.vue?vue&type=template&id=3b0ac162&scoped=true"
import script from "./weixin.vue?vue&type=script&lang=js"
export * from "./weixin.vue?vue&type=script&lang=js"

import "./weixin.vue?vue&type=style&index=0&id=3b0ac162&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b0ac162"

export default script